export const SCENE_KEYS = Object.freeze({
  PRELOAD_SCENE: 'PRELOAD_SCENE',
  WORLD_SCENE: 'WORLD_SCENE',
  BATTLE_SCENE: 'BATTLE_SCENE',
  ENTRY_SCENE: 'ENTRY_SCENE',
  PROFILE_SETUP_SCENE: 'PROFILE_SETUP_SCENE',
  PROFILE_SCENE: 'PROFILE_SCENE',
  OPTIONS_SCENE: 'OPTIONS_SCENE',
  TEST_SCENE: 'TEST_SCENE',
  MONSTER_PARTY_SCENE: 'MONSTER_PARTY_SCENE',
  PC_BOX_SCENE: 'PC_BOX_SCENE',
  MONSTER_DETAILS_SCENE: 'MONSTER_DETAILS_SCENE',
  INVENTORY_SCENE: 'INVENTORY_SCENE',
  CUTSCENE_SCENE: 'CUTSCENE_SCENE',
  DIALOG_SCENE: 'DIALOG_SCENE',
  CURRENCY_HUD_SCENE: 'CURRENCY_HUD_SCENE',
  QUESTS_SCENE: 'QUESTS_SCENE',
  MARKETPLACE_SCENE: 'MARKETPLACE_SCENE',
  PVP_BATTLE_SCENE: 'PVP_BATTLE_SCENE',
  CARD_SHOP_SCENE: 'CARD_SHOP_SCENE',
  WORLD_HUD_SCENE: 'WORLD_HUD_SCENE',
  MOBILE_CONTROLS_SCENE: 'MOBILE_CONTROLS_SCENE',
  SETTINGS_SCENE: 'SETTINGS_SCENE',
  MAP_SCENE: 'MAP_SCENE',
  LEADERBOARD_SCENE: 'LEADERBOARD_SCENE',
  FRIENDS_SCENE: 'FRIENDS_SCENE',
  EVOLUTION_SCENE: 'EVOLUTION_SCENE',
  TAP_FEEDBACK_SCENE: 'TAP_FEEDBACK_SCENE',
  HOW_TO_PLAY_SCENE: 'HOW_TO_PLAY_SCENE',
  VAULT_SCENE: 'VAULT_SCENE',
});
